import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import stringToColor from 'flarum/common/utils/stringToColor';
/**
 * A member's avatar from the plain shape Concourse's endpoints send — a
 * picture, or their initial on the colour core would give them — without a
 * user model in the store.
 */
export default class Face extends Component {
  view() {
    const {
      person,
      link,
      className
    } = this.attrs;
    const name = person.displayName || '?';
    const inner = person.avatarUrl ? m("img", {
      className: "ConcourseFace-img",
      src: person.avatarUrl,
      alt: "",
      loading: "lazy"
    }) : m("span", {
      className: "ConcourseFace-initial",
      style: {
        '--face-color': '#' + stringToColor(name)
      }
    }, name.charAt(0).toUpperCase());
    const cls = 'ConcourseFace ' + (className || '');
    return link ? m(Link, {
      className: cls,
      href: app.route('user', {
        username: person.slug
      }),
      title: name,
      "aria-label": name
    }, inner) : m("span", {
      className: cls,
      title: name
    }, inner);
  }
}
flarum.reg.add('ernestdefoe-concourse', 'forum/components/Face', Face);